import React, { FC, ReactElement } from 'react';
import withLocalization from '../hoc/withLocalization';
import './RoomTypeInformation.scss';
interface RoomTypeProp {
  localize?: any;
}

const RoomTypeInformation: FC<RoomTypeProp> = (props: RoomTypeProp): ReactElement => {
  const { localize } = props;

  return (
    <React.Fragment>
      <div className="roomTypePad">
        <h5 className="h3Mont palmColor paddingTopBot upperCase">
          {localize('preview-sales-engine.static-content.copy.select-offer-page.select-offer-button')}
        </h5>
      </div>
    </React.Fragment>
  );
};
export default React.memo(withLocalization(RoomTypeInformation));
